export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Analyse IA des photos du produit"])},
        "analyzed_at": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Analysées le ", _interpolate(_named("date"))])},
        "not_analyzed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Photos pas encore analysées."])},
        "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Analyse indisponible"])},
        "overall_verdict": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verdict global :"])},
        "checks_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vérifications"])},
        "column_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vérification"])},
        "column_verdict": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verdict"])},
        "column_reason": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Raison"])},
        "retry_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relancer l'analyse"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AI analysis of the product photos"])},
        "analyzed_at": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Analyzed on ", _interpolate(_named("date"))])},
        "not_analyzed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Photos not yet analyzed."])},
        "unavailable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Analysis unavailable"])},
        "overall_verdict": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overall verdict:"])},
        "checks_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Checks"])},
        "column_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Check"])},
        "column_verdict": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verdict"])},
        "column_reason": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reason"])},
        "retry_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Retry analysis"])}
      }
    }
  })
}
